export enum NoteAndActivityTypeEnum {
    General = 1,
    AssignmentNote = 14,
    Orientation = 15,
    System = 31,
    CallNoAnswer = 32,
    CallTalked = 33,
    Ticket = 34,
    SystemEmail = 35,
    LabProviderEmail = 36,
    Experience = 37,
    PreferenceUpdate = 38

}

export enum NoteSourceTypeEnum {
    ProfileNote = 1,
    OrientationNote = 2,
    EmailNote = 3,
    Tickets = 4,
    ComplianceProviderEmail = 5
}

export enum UserTypeEnum {
    System = 0,
    User = 1
}
export enum EmailNoteType {
    MissingAndExpiringEmail = 1,
    WelcomeEmail = 2
}
export enum LabProviderEmailType {
    ConfirmationEmail = 1,
    ExceptionEmail = 2
}
